import { createAsyncThunk } from '@reduxjs/toolkit'
import ProfileStatus from './profile-status-model'
import {
  delete_profileStatus,
  load_profileStatuss,
  store_profileStatus,
} from './profileStatus-service'

export const LoadProfileStatussAsync = createAsyncThunk<any, any>(
  'composer/load/profileStatus',
  async (params: { uid: string }) => {
    return await load_profileStatuss(params)
  },
)

export const CreateProfileStatusAsync = createAsyncThunk<any, any>(
  'composer/create/profileStatus',
  async (params: ProfileStatus) => {
    return await store_profileStatus(params)
  },
)

export const DeleteProfileStatusAsync = createAsyncThunk<any, any>(
  'composer/delete/profileStatus',
  async (params) => {
    return await delete_profileStatus(params)
  },
)
